import { render, staticRenderFns } from "./DesktopModal.vue?vue&type=template&id=23b8f1b0&"
import script from "./DesktopModal.vue?vue&type=script&lang=js&"
export * from "./DesktopModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports